import Slider from '../slider';

export default (element) => {
  const createInspirationSlider = () => {
    const slider = new Slider({
      el: element.querySelector('[data-inspiration-slider]'),
      options: {
        slidesPerView: 'auto',
        spaceBetween: 18,
        direction: "horizontal",
        keyboard: true,
        breakpoints: {
          1024: {
            slidesPerView: 6,
          },
        },
        navigation: {
          nextEl: '[data-inspiration-slider-wrapper] .swiper-button-next',
          prevEl: '[data-inspiration-slider-wrapper] .swiper-button-prev',
          disabledClass: '!hidden',
        },
      },
    });
    return slider;
  };

  const createArticlesSlider = () => {
    const slider = new Slider({
      el: element.querySelector('[data-articles-slider]'),
      options: {
        slidesPerView: 1.9,
        spaceBetween: 6,
        direction: "horizontal",
        keyboard: true,
        breakpoints: {
          1024: {
            spaceBetween: 8,
            slidesPerView: 5.1,
          },
        },
        navigation: {
          nextEl: '[data-articles-slider] .swiper-button-next',
          prevEl: '[data-articles-slider] .swiper-button-prev',
          disabledClass: '!hidden',
        },
      },
    });
    return slider;
  };

  createInspirationSlider();
  createArticlesSlider();
};
